import { hideLoading, showLoading } from 'react-redux-loading-bar';

import api from '../../utils/api/api';
import { receiveThreadActionCreator } from '../thread/action';
import { receiveUsersActionCreator } from '../users/action';

const asyncPopulateUserThreads = () => {
  return async (dispatch) => {
    dispatch(showLoading());

    try {
      const users = await api.getAllUsers();
      const threads = await api.getAllThreads();

      dispatch(receiveThreadActionCreator(threads));
      dispatch(receiveUsersActionCreator(users));
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

export { asyncPopulateUserThreads };
